import React, { createContext, useContext, useState, useEffect } from 'react';

const translations = {
  es: {
    nav: { home: 'Inicio', catalog: 'Catálogo', about: 'Nosotros', contact: 'Contacto' },
    hero: {
      title: 'Marketplace de Enlaces Premium',
      subtitle: 'Encuentra los mejores sitios web para tus campañas de link building. Filtros avanzados, métricas detalladas y la mejor selección de dominios.',
      cta: 'Explorar Catálogo',
      stats: { products: 'Productos', countries: 'Países', languages: 'Idiomas' },
    },
    filters: {
      title: 'Filtros', search: 'Buscar por dominio...', price: 'Precio', priceRange: 'Rango de precio',
      minPrice: 'Mín', maxPrice: 'Máx', dr: 'Domain Rating', drRange: 'Rango DR', traffic: 'Tráfico Orgánico',
      trafficRange: 'Rango de tráfico', country: 'País', allCountries: 'Todos los países', language: 'Idioma',
      allLanguages: 'Todos los idiomas', linkType: 'Tipo de Enlace', allTypes: 'Todos los tipos',
      sensitiveTopics: 'Temáticas Sensibles', acceptsSensitive: 'Acepta sensibles', advertising: 'Publicidad',
      hasAdLabel: 'Etiqueta publicitaria', clear: 'Limpiar filtros', apply: 'Aplicar', results: 'resultados',
    },
    sensitiveTopics: { casino: 'Casino', erotic: 'Erótico', gambling: 'Apuestas', cbd: 'CBD', cannabis: 'Cannabis', vpn: 'VPN', tarot: 'Tarot', crypto: 'Criptomonedas', forex: 'Forex' },
    linkTypes: { dofollow: 'DoFollow', nofollow: 'NoFollow', sponsored: 'Patrocinado', ugc: 'UGC' },
    product: {
      viewDetails: 'Ver Detalles', domain: 'Dominio', price: 'Precio', dr: 'DR', traffic: 'Tráfico', country: 'País',
      language: 'Idioma', linkType: 'Tipo Enlace', adLabel: 'Etiqueta Pub.', sensitive: 'Sensibles', accepts: 'Acepta',
      noAccepts: 'No acepta', yes: 'Sí', no: 'No', monthly: '/mes', acceptedTopics: 'Temáticas aceptadas',
      notAccepted: 'No acepta temáticas sensibles', contact: 'Contactar', addToList: 'Añadir a Lista',
      backToCatalog: 'Volver al Catálogo', specifications: 'Especificaciones', about: 'Sobre este sitio',
    },
    footer: { description: 'El marketplace líder en enlaces de calidad para tu estrategia SEO.', links: 'Enlaces', legal: 'Legal', privacy: 'Privacidad', terms: 'Términos', cookies: 'Cookies', rights: 'Todos los derechos reservados.' },
    general: { loading: 'Cargando...', noResults: 'No se encontraron resultados', tryOther: 'Intenta con otros filtros' },
  },
  en: {
    nav: { home: 'Home', catalog: 'Catalog', about: 'About', contact: 'Contact' },
    hero: {
      title: 'Premium Link Marketplace',
      subtitle: 'Find the best websites for your link building campaigns. Advanced filters, detailed metrics, and the best domain selection.',
      cta: 'Explore Catalog',
      stats: { products: 'Products', countries: 'Countries', languages: 'Languages' },
    },
    filters: {
      title: 'Filters', search: 'Search by domain...', price: 'Price', priceRange: 'Price range',
      minPrice: 'Min', maxPrice: 'Max', dr: 'Domain Rating', drRange: 'DR Range', traffic: 'Organic Traffic',
      trafficRange: 'Traffic range', country: 'Country', allCountries: 'All countries', language: 'Language',
      allLanguages: 'All languages', linkType: 'Link Type', allTypes: 'All types',
      sensitiveTopics: 'Sensitive Topics', acceptsSensitive: 'Accepts sensitive', advertising: 'Advertising',
      hasAdLabel: 'Ad label', clear: 'Clear filters', apply: 'Apply', results: 'results',
    },
    sensitiveTopics: { casino: 'Casino', erotic: 'Erotic', gambling: 'Gambling', cbd: 'CBD', cannabis: 'Cannabis', vpn: 'VPN', tarot: 'Tarot', crypto: 'Cryptocurrency', forex: 'Forex' },
    linkTypes: { dofollow: 'DoFollow', nofollow: 'NoFollow', sponsored: 'Sponsored', ugc: 'UGC' },
    product: {
      viewDetails: 'View Details', domain: 'Domain', price: 'Price', dr: 'DR', traffic: 'Traffic', country: 'Country',
      language: 'Language', linkType: 'Link Type', adLabel: 'Ad Label', sensitive: 'Sensitive', accepts: 'Accepts',
      noAccepts: "Doesn't accept", yes: 'Yes', no: 'No', monthly: '/mo', acceptedTopics: 'Accepted topics',
      notAccepted: "Doesn't accept sensitive topics", contact: 'Contact', addToList: 'Add to List',
      backToCatalog: 'Back to Catalog', specifications: 'Specifications', about: 'About this site',
    },
    footer: { description: 'The leading marketplace for quality links for your SEO strategy.', links: 'Links', legal: 'Legal', privacy: 'Privacy', terms: 'Terms', cookies: 'Cookies', rights: 'All rights reserved.' },
    general: { loading: 'Loading...', noResults: 'No results found', tryOther: 'Try different filters' },
  },
  de: {
    nav: { home: 'Startseite', catalog: 'Katalog', about: 'Über uns', contact: 'Kontakt' },
    hero: {
      title: 'Premium Link Marktplatz',
      subtitle: 'Finden Sie die besten Websites für Ihre Linkbuilding-Kampagnen. Erweiterte Filter, detaillierte Metriken und die beste Domain-Auswahl.',
      cta: 'Katalog erkunden',
      stats: { products: 'Produkte', countries: 'Länder', languages: 'Sprachen' },
    },
    filters: {
      title: 'Filter', search: 'Nach Domain suchen...', price: 'Preis', priceRange: 'Preisbereich',
      minPrice: 'Min', maxPrice: 'Max', dr: 'Domain Rating', drRange: 'DR Bereich', traffic: 'Organischer Traffic',
      trafficRange: 'Traffic-Bereich', country: 'Land', allCountries: 'Alle Länder', language: 'Sprache',
      allLanguages: 'Alle Sprachen', linkType: 'Linktyp', allTypes: 'Alle Typen',
      sensitiveTopics: 'Sensible Themen', acceptsSensitive: 'Akzeptiert sensible', advertising: 'Werbung',
      hasAdLabel: 'Werbelabel', clear: 'Filter löschen', apply: 'Anwenden', results: 'Ergebnisse',
    },
    sensitiveTopics: { casino: 'Casino', erotic: 'Erotik', gambling: 'Glücksspiel', cbd: 'CBD', cannabis: 'Cannabis', vpn: 'VPN', tarot: 'Tarot', crypto: 'Kryptowährung', forex: 'Forex' },
    linkTypes: { dofollow: 'DoFollow', nofollow: 'NoFollow', sponsored: 'Gesponsert', ugc: 'UGC' },
    product: {
      viewDetails: 'Details anzeigen', domain: 'Domain', price: 'Preis', dr: 'DR', traffic: 'Traffic', country: 'Land',
      language: 'Sprache', linkType: 'Linktyp', adLabel: 'Werbelabel', sensitive: 'Sensibel', accepts: 'Akzeptiert',
      noAccepts: 'Akzeptiert nicht', yes: 'Ja', no: 'Nein', monthly: '/Monat', acceptedTopics: 'Akzeptierte Themen',
      notAccepted: 'Akzeptiert keine sensiblen Themen', contact: 'Kontakt', addToList: 'Zur Liste hinzufügen',
      backToCatalog: 'Zurück zum Katalog', specifications: 'Spezifikationen', about: 'Über diese Seite',
    },
    footer: { description: 'Der führende Marktplatz für Qualitätslinks für Ihre SEO-Strategie.', links: 'Links', legal: 'Rechtliches', privacy: 'Datenschutz', terms: 'AGB', cookies: 'Cookies', rights: 'Alle Rechte vorbehalten.' },
    general: { loading: 'Lädt...', noResults: 'Keine Ergebnisse gefunden', tryOther: 'Versuchen Sie andere Filter' },
  },
  fr: {
    nav: { home: 'Accueil', catalog: 'Catalogue', about: 'À propos', contact: 'Contact' },
    hero: {
      title: 'Marketplace de Liens Premium',
      subtitle: 'Trouvez les meilleurs sites web pour vos campagnes de link building. Filtres avancés, métriques détaillées et la meilleure sélection de domaines.',
      cta: 'Explorer le Catalogue',
      stats: { products: 'Produits', countries: 'Pays', languages: 'Langues' },
    },
    filters: {
      title: 'Filtres', search: 'Rechercher par domaine...', price: 'Prix', priceRange: 'Gamme de prix',
      minPrice: 'Min', maxPrice: 'Max', dr: 'Domain Rating', drRange: 'Plage DR', traffic: 'Trafic Organique',
      trafficRange: 'Plage de trafic', country: 'Pays', allCountries: 'Tous les pays', language: 'Langue',
      allLanguages: 'Toutes les langues', linkType: 'Type de lien', allTypes: 'Tous les types',
      sensitiveTopics: 'Sujets Sensibles', acceptsSensitive: 'Accepte les sensibles', advertising: 'Publicité',
      hasAdLabel: 'Label publicitaire', clear: 'Effacer les filtres', apply: 'Appliquer', results: 'résultats',
    },
    sensitiveTopics: { casino: 'Casino', erotic: 'Érotique', gambling: 'Jeux d\'argent', cbd: 'CBD', cannabis: 'Cannabis', vpn: 'VPN', tarot: 'Tarot', crypto: 'Cryptomonnaie', forex: 'Forex' },
    linkTypes: { dofollow: 'DoFollow', nofollow: 'NoFollow', sponsored: 'Sponsorisé', ugc: 'UGC' },
    product: {
      viewDetails: 'Voir les détails', domain: 'Domaine', price: 'Prix', dr: 'DR', traffic: 'Trafic', country: 'Pays',
      language: 'Langue', linkType: 'Type de lien', adLabel: 'Label Pub.', sensitive: 'Sensibles', accepts: 'Accepte',
      noAccepts: 'N\'accepte pas', yes: 'Oui', no: 'Non', monthly: '/mois', acceptedTopics: 'Sujets acceptés',
      notAccepted: 'N\'accepte pas les sujets sensibles', contact: 'Contacter', addToList: 'Ajouter à la liste',
      backToCatalog: 'Retour au Catalogue', specifications: 'Spécifications', about: 'À propos de ce site',
    },
    footer: { description: 'Le marketplace leader pour des liens de qualité pour votre stratégie SEO.', links: 'Liens', legal: 'Légal', privacy: 'Confidentialité', terms: 'Conditions', cookies: 'Cookies', rights: 'Tous droits réservés.' },
    general: { loading: 'Chargement...', noResults: 'Aucun résultat trouvé', tryOther: 'Essayez d\'autres filtres' },
  },
  it: {
    nav: { home: 'Home', catalog: 'Catalogo', about: 'Chi siamo', contact: 'Contatto' },
    hero: {
      title: 'Marketplace di Link Premium',
      subtitle: 'Trova i migliori siti web per le tue campagne di link building. Filtri avanzati, metriche dettagliate e la migliore selezione di domini.',
      cta: 'Esplora il Catalogo',
      stats: { products: 'Prodotti', countries: 'Paesi', languages: 'Lingue' },
    },
    filters: {
      title: 'Filtri', search: 'Cerca per dominio...', price: 'Prezzo', priceRange: 'Fascia di prezzo',
      minPrice: 'Min', maxPrice: 'Max', dr: 'Domain Rating', drRange: 'Range DR', traffic: 'Traffico Organico',
      trafficRange: 'Range di traffico', country: 'Paese', allCountries: 'Tutti i paesi', language: 'Lingua',
      allLanguages: 'Tutte le lingue', linkType: 'Tipo di link', allTypes: 'Tutti i tipi',
      sensitiveTopics: 'Argomenti Sensibili', acceptsSensitive: 'Accetta sensibili', advertising: 'Pubblicità',
      hasAdLabel: 'Etichetta pubblicitaria', clear: 'Cancella filtri', apply: 'Applica', results: 'risultati',
    },
    sensitiveTopics: { casino: 'Casinò', erotic: 'Erotico', gambling: 'Gioco d\'azzardo', cbd: 'CBD', cannabis: 'Cannabis', vpn: 'VPN', tarot: 'Tarocchi', crypto: 'Criptovaluta', forex: 'Forex' },
    linkTypes: { dofollow: 'DoFollow', nofollow: 'NoFollow', sponsored: 'Sponsorizzato', ugc: 'UGC' },
    product: {
      viewDetails: 'Vedi Dettagli', domain: 'Dominio', price: 'Prezzo', dr: 'DR', traffic: 'Traffico', country: 'Paese',
      language: 'Lingua', linkType: 'Tipo Link', adLabel: 'Etichetta Pub.', sensitive: 'Sensibili', accepts: 'Accetta',
      noAccepts: 'Non accetta', yes: 'Sì', no: 'No', monthly: '/mese', acceptedTopics: 'Argomenti accettati',
      notAccepted: 'Non accetta argomenti sensibili', contact: 'Contatta', addToList: 'Aggiungi alla Lista',
      backToCatalog: 'Torna al Catalogo', specifications: 'Specifiche', about: 'Informazioni su questo sito',
    },
    footer: { description: 'Il marketplace leader per link di qualità per la tua strategia SEO.', links: 'Link', legal: 'Legale', privacy: 'Privacy', terms: 'Termini', cookies: 'Cookie', rights: 'Tutti i diritti riservati.' },
    general: { loading: 'Caricamento...', noResults: 'Nessun risultato trovato', tryOther: 'Prova altri filtri' },
  },
};

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    const saved = localStorage.getItem('marketplace-language');
    return saved || 'es';
  });

  useEffect(() => {
    localStorage.setItem('marketplace-language', language);
  }, [language]);

  const t = (key) => {
    const keys = key.split('.');
    let value = translations[language];
    for (const k of keys) {
      value = value?.[k];
    }
    return value || key;
  };

  const toggleLanguage = () => {
    const langs = ['es', 'en', 'de', 'fr', 'it'];
    const currentIndex = langs.indexOf(language);
    const nextIndex = (currentIndex + 1) % langs.length;
    setLanguage(langs[nextIndex]);
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, toggleLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};
